import { useIntl } from 'react-intl';

import { IRestaurantNode } from 'generated/rbi-graphql';
import { useGeolocation } from 'state/geolocation';
import { useLocale } from 'state/intl';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { Geography } from 'utils/geography';
import { readableDistanceFromStore } from 'utils/restaurant';

interface UserDistanceTextOptions {
  restaurant: IRestaurantNode;
}

const DEFAULT_SHOW_STORE_LOCATOR = true;

export const useDistanceText = ({
  restaurant: { latitude, longitude },
}: UserDistanceTextOptions) => {
  const { activeCoordinates, isPermissionGranted } = useGeolocation();
  const { formatMessage } = useIntl();
  const { region } = useLocale();
  const showStoreLocator =
    useFlag(LaunchDarklyFlag.SHOW_STORE_LOCATOR) ?? DEFAULT_SHOW_STORE_LOCATOR;
  let distanceText;

  if (activeCoordinates && latitude && longitude) {
    const distance = Geography.coordinateDistance(
      { latitude: activeCoordinates.lat, longitude: activeCoordinates.lng },
      {
        latitude,
        longitude,
      }
    );
    if (showStoreLocator || isPermissionGranted) {
      distanceText = readableDistanceFromStore(distance, region, formatMessage);
    }
  }

  return distanceText;
};
